import { defineMessages } from 'react-intl-next';

const messagesBase = defineMessages({
	createTemplate: {
		id: 'snippets.createTemplate',
		defaultMessage: 'Create template',
		description: 'Label for the create template button in the contextual toolbar',
	},
	createTemplateLozenge: {
		id: 'snippets.createTemplateLozenge',
		defaultMessage: 'New',
		description: 'Lozenge label for the create template button in the contextual toolbar',
	},
	createTemplateModalTitle: {
		id: 'snippets.createTemplateModalTitle',
		defaultMessage: 'Create template',
		description: 'Title for the create template modal',
	},
	createTemplateModalDescription: {
		id: 'snippets.createTemplateModalDescription',
		defaultMessage: 'Save content and easily reuse it through / menu.',
		description: 'Description for the create template modal',
	},
	createTemplateModalNamePlaceholder: {
		id: 'snippets.createTemplateModalNamePlaceholder',
		defaultMessage: 'Enter template name',
		description: 'Placeholder for the template name input in the create template modal',
	},
	createTemplateModalNameLabel: {
		id: 'snippets.createTemplateModalNameLabel',
		defaultMessage: 'Name',
		description: 'Name label for the create template modal',
	},
	createTemplateModalNameHelper: {
		id: 'snippets.createTemplateModalNameHelper',
		defaultMessage: 'Use a name to find your Block Template',
		description: 'Helper message for the template name input in the create template modal',
	},
	createTemplateModalNameError: {
		id: 'snippets.createTemplateModalNameError',
		defaultMessage: 'Name is required',
		description: 'Error message for the template name input in the create template modal',
	},
	createTemplateModalDescriptionLabel: {
		id: 'snippets.createTemplateModalDescriptionLabel',
		defaultMessage: 'Description',
		description: 'Description label for the create template modal',
	},
	createTemplateModalDescriptionPlaceholder: {
		id: 'snippets.createTemplateModalDescriptionPlaceholder',
		defaultMessage: 'Enter template description',
		description: 'Placeholder for the description input in the create template modal',
	},
	createTemplateModalAdfError: {
		id: 'snippets.createTemplateModalAdfError',
		defaultMessage: 'Something went wrong, please make a new content selection',
		description: 'Error message for when the selected ADF is invalid',
	},
	createTemplateModalCancelButton: {
		id: 'snippets.createTemplateModalCancelButton',
		defaultMessage: 'Cancel',
		description: 'Cancel button text for the create template modal',
	},
	createTemplateModalCreateButton: {
		id: 'snippets.createTemplateModalCreateButton',
		defaultMessage: 'Create',
		description: 'Create button text for the create template modal',
	},
	createTemplateModalErrorFlagTitle: {
		id: 'snippets.createTemplateModalErrorFlagTitle',
		defaultMessage: 'Could not create template',
		description: 'Title for the error flag shown when template creation fails',
	},
	createTemplateModalErrorFlagDescription: {
		id: 'snippets.createTemplateModalErrorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Description for the error flag shown when template creation fails',
	},
	createTemplateModalSuccessFlagTitle: {
		id: 'snippets.createTemplateModalSuccessFlagTitle',
		defaultMessage: 'Template "{snippetName}" created',
		description: 'Title for the success flag shown when template creation succeeds',
	},
	createTemplateModalSuccessFlagDescription: {
		id: 'snippets.createTemplateModalSuccessFlagDescription',
		defaultMessage: 'You can now use it from the / menu',
		description: 'Description for the success flag shown when template creation succeeds',
	},
	snippetBy: {
		id: 'snippets.quick-insert.by',
		defaultMessage: 'by {name}',
		description: 'Description text showing who created the snippet, with the creator name',
	},
	template: {
		id: 'snippets.quick-insert.template',
		defaultMessage: 'template',
		description: 'Keyword for template search in quick insert',
	},
});

export const messages = messagesBase;
